/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useEffect } from "react";
import { useAuth } from "cms/auth/hooks/use-auth";

const apiPersistCache = {
    token: "",
};

/**
 * Ensures the auth token is always up to date for use in Redux-style
 * middlewares.
 */
const useApiPersistCache = () => {
    const { token } = useAuth();

    // FIXME: remove this! get token fresh/always
    // hack to set the token for persist middleware
    useEffect(() => {
        apiPersistCache.token = token;
    }, [token]);
};

export { 
    apiPersistCache,
    useApiPersistCache
};
